/** The "Revised readings" list, as words.
 *
 *  A revision is a reading the vendor sent that disagrees with what
 *  `measurement` holds (db/016, runner.upsert): the value a collecting pass
 *  replaced (the daily run, or since intake v2 phase 2 the live poll, the
 *  sweep or telemetry — live and telemetry carry no run, so the sentence
 *  names no pass), a blank or `backfill --fill-only` value kept ours over,
 *  or the second of two readings for one time. Values are shown exactly as stored, never
 *  through formatNumber: the difference between two readings is often in the
 *  ninth decimal, and a rounded pair would read as identical.
 */
import type { Revision } from '../api/types'

export const OUTCOMES: Revision['outcome'][] = ['replaced', 'kept', 'duplicate']

const LABEL: Record<Revision['outcome'], string> = {
  replaced: 'Replaced', kept: 'Kept ours', duplicate: 'Second reading',
}

export function outcomeLabel(outcome: Revision['outcome']): string {
  return LABEL[outcome]
}

export function exactValue(value: number | null): string {
  return value === null ? 'blank' : String(value)
}

export function revisionSentence(r: Revision): string {
  const stored = exactValue(r.stored_value)
  const vendor = exactValue(r.vendor_value)
  switch (r.outcome) {
    case 'replaced':
      return `The vendor later sent ${vendor}; it replaced ${stored}.`
    case 'kept':
      return r.vendor_value === null
        ? `The vendor sent a blank; ${stored} was kept.`
        : `The vendor now sends ${vendor}; ${stored} was kept.`
    case 'duplicate':
      return `Two readings arrived for this time; ${stored} was stored, ${vendor} is kept here.`
  }
}
